import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { FormFieldsValidationService } from 'src/sb-modules/Frontend-form-field-module/common/services/form-fields-validation.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule, NgClass, FormFieldLabelComponent],
})
export class RadioComponent implements OnInit {
    @Input() formField: Field | ClientField;

    constructor(
        public formService: FormService,
        private formFieldsValidationService: FormFieldsValidationService,
    ) {}

    ngOnInit() {
        if (
            this.formField.value &&
            !this.formFieldsValidationService.isValueInPossibleValuesList(this.formField, this.formField.value)
        ) {
            this.formField.value = null;
        }
    }
}
